import get from "lodash/get";

// components
import LocationSpaceCard from "./LocationSpaceCard";
import LocationSpaceCardLoading from "./LocationSpaceCardLoading";

// helpers
import useQueryParams from "@/hooks/useQueryParams";
import queryString from "@/helpers/queryString";

// interfaces
import { ILocationSpaceItem } from "@/types/api/Locations";

// assets
import styles from "@/assets/styles/pages/location-single-page/location-single-page-components.module.scss";


interface LocationSpacesContainerBodyProps {
  title: string;
  currencyToUse: string;
  spacesList: ILocationSpaceItem[];
  refetch: () => void;
  isLoading: boolean;
  isRestricted?: boolean;
  onRestrictedButtonClick?: (e: React.MouseEvent<HTMLElement>) => void;
  handleSendAnalytics?: () => void;
}

const LocationSpacesContainerBody = (props: LocationSpacesContainerBodyProps) => {
  const {
    title,
    currencyToUse,
    spacesList,
    refetch,
    isLoading,
    isRestricted,
    onRestrictedButtonClick,
    handleSendAnalytics,
  } = props;
  const [{ preview }] = useQueryParams();

  const handleSpaceCardClick = (e: React.MouseEvent<HTMLElement>) => {
    if (isRestricted) {
      onRestrictedButtonClick && onRestrictedButtonClick(e);
    }
  }

  const renderSpacesList = () => {
    return (
      <div className={styles["locl-location-page-spaces-container-body__spaces-list"]}>
        {
          (spacesList || []).map((item, index) => {
            const spaceQueryString = queryString.stringify({ preview });
            const isShowFxPrice = get(item, "location.currency.code", "") !== currencyToUse;

            return (
              <LocationSpaceCard
                key={`${index}-${item.slug}`}
                images={(item as ILocationSpaceItem).pictures.map((picture) => ({
                  src: picture.thumbnailImage?.url || picture?.image?.url,
                  previewSrc: picture?.image?.url,
                  alt: item.name || (picture as unknown as { name: string })?.name
                }))}
                link={`/location/${item.location.slug}/space/${item.slug}${spaceQueryString && `?${spaceQueryString}`}`}
                currency={currencyToUse}
                fullSpaceData={item as ILocationSpaceItem}
                onAddToCampaign={refetch}
                isShowFxPrice={isShowFxPrice}
                handleSendAnalytics={handleSendAnalytics}
                onClick={handleSpaceCardClick}
              />
            );
          })
        }
      </div>
    );
  };


  return (
    <div
      className={styles["locl-location-page-spaces-container-body"]}
      data-testid="locl-location-page-spaces-container-body"
    >
      <div
        className={styles["locl-location-page-spaces-container-body__title"]}
        data-testid="locl-location-page-spaces-container-body-title"
      >
        { title }
      </div>
      {
        isLoading
          ? (
            <div className={styles["locl-location-page-spaces-container-body__spaces-list"]}>
              { new Array(4).fill(0).map((_, index) => <LocationSpaceCardLoading key={index}/>) }
            </div>
          )
          : renderSpacesList()
      }
    </div>
  );
};

export default LocationSpacesContainerBody;
